module.exports = __webpack_public_path__ + "static/media/neocities.e96f4e34.svg";